import {Directive, inject, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {PermissionProvider} from '@xmedical/core';

@Directive({
    selector: '[xuiPermissionRequired]',
    standalone: true
})
export class PermissionRequiredDirective implements OnInit, OnDestroy {
  private permissionProvider = inject(PermissionProvider);
  private templateRef = inject(TemplateRef<any>);
  private viewContainer = inject(ViewContainerRef);

  private _xuiPermissionRequired: string;
  private _xuiPermissionRequiredElse: TemplateRef<any>|null = null;
  private _xuiPermissionRequiredCondition: boolean|null = null;
  private permissionsLoadedSubscription: Subscription;
  private conditionSubscription: Subscription;

  @Input() set xuiPermissionRequired(permission: string) {
    this._xuiPermissionRequired = permission;
    this.updateView();
  }
  @Input() set xuiPermissionRequiredElse(elseRef: TemplateRef<any>|null) {
    this._xuiPermissionRequiredElse = elseRef === null ? null : elseRef;
    this.updateView();
  }
  @Input() set xuiPermissionRequiredCondition(condition: boolean|null|Observable<boolean>) {
    this.conditionSubscription?.unsubscribe();
    if (condition instanceof Observable) {
      this.conditionSubscription = condition.subscribe(value => {
        this._xuiPermissionRequiredCondition = value;
        this.updateView();
      });
    } else {
      this._xuiPermissionRequiredCondition = condition === null ? null : condition;
      this.updateView();
    }
  }

  ngOnDestroy(): void {
    this.conditionSubscription?.unsubscribe();
    this.permissionsLoadedSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    if (!this.permissionProvider.hasPermissions) {
      this.permissionsLoadedSubscription = this.permissionProvider.permissionsLoaded$.subscribe(() => {
        this.updateView();
      });
    }
  }

  private updateView(): void {
    this.viewContainer.clear();
    if (this.permissionProvider.hasPermission(this._xuiPermissionRequired)) {
      if (this._xuiPermissionRequiredCondition !== null && this._xuiPermissionRequiredCondition || this._xuiPermissionRequiredCondition === null) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    } else {
      if (this._xuiPermissionRequiredElse) {
        if (this._xuiPermissionRequiredCondition !== null && this._xuiPermissionRequiredCondition || this._xuiPermissionRequiredCondition === null) {
          this.viewContainer.createEmbeddedView(this._xuiPermissionRequiredElse);
        }
      }
    }
  }

}
